import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Subject } from 'rxjs';
import { Globals } from "../../globals";
import { StockServices } from "../stock/services";
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { PosElementPersonPage } from '../components/pos/pos-element-person/pos-element-person';
import { ModalController } from 'ionic-angular';
import { AnalyticsServices } from '../services/analyticsServices';

interface Room {
    UID: string;
}

interface Table {
    UID: string;
    name: string;
    ticket: Ticket;
    cash_static: any;
    cash_uid: any;
    type: string;
    //order:any;
}

type Ticket = {
    UID: string;
    number: any;
    cash_uid: any;
    date: Date;
    list: any;
    amount: number;
    payment: boolean;
    payment_type: string;
    waiter: string;
    waiter_uid: string;
    created_at: any;
    tip: number;
}

interface Menu {
    UID: string;
}

interface Dish {
    UID: string;
    tags: any;
}

interface Product {
    UID: string;
    tags: any;
}



interface Cash {
    UID: string;
    name: string;
    number: any;
    _active: boolean;
}

interface Order {
    UID: string;
    UID_RESTAURANT: string;
    hour: string;
    sections: any;
    show_kitchen: boolean;
    table: string;
    type: string;
    waiter: string;
    waiter_uid: string;
}

@Injectable()
export class OrdersCoServices {
    //TMP
    public menu_select_room = 'room';
    public section_select = 'dish';
    public menu_select = '';
    public section_order = this.translate.instant('general-todos');
    public section_menu_order = 'Primeros';
    public room_selected_map: boolean;
    public selected_type: any;
    public firestore: any;
    public ticket_uid: any;
    public order_tmp: any = [];
    public listall_print: any = [];
    public listchange_print: any = [];
    public is_combo: boolean = false;
    public selected_tag: any;
    //
    update_state: boolean = false;
    element: any;
    i: any;
    j: any;
    //print
    orders_print: string = 'all';
    public print_order_part: any; //Sirve para cuando imprimimos solo una orden. Es donde guardamos los valores de la orden.
    public print_order: any; //Sirve para cuando imprimimos solo una orden. para mostrar COMBO
    count_elements: number = 0; //para mostrar mientras pide los elementos que esta introduciendo
    //order_kitchen
    order_kitchen_table_name: any;
    order_kitchen_persons: any;
    order_kitchen_table_waiter: any;
    order_kitchen_table_hour: any;
    order_kitchen_order: any = [];
    order_kitchen_sections: any = [];
    kitchen_filter: string;
    //customer
    selectedPersonId: any;
    public customer_note: any;
    //elements tags
    public elements_tags: any = [];
    public active_tags: any = [];
    public elements_active_tags: any = [];
    //Rooms
    roomsCol: AngularFirestoreCollection<Room>;
    rooms: Observable<Room[]>;
    roomsDoc: AngularFirestoreDocument<Room>;
    room: any;
    room_selected_uid: any;
    room_selected_name: any;
    //Tables
    tablesCol: AngularFirestoreCollection<Table>;
    tables: Observable<Table[]>;
    tables_array: any;
    public table_tmp: Table;
    tablesDoc: AngularFirestoreDocument<Table>;
    table: any;
    selected_table_tpv: any;
    selected_table_tpv_index: any;
    table_bar_index: any;
    //print
    public total_ticket_indv_print = 0;
    public subtotal_ticket_indv_print = 0;
    //Tickets
    ticketsCol: AngularFirestoreCollection<Ticket>;
    tickets: Observable<Ticket[]>;
    ticketDoc: AngularFirestoreDocument<Ticket>;
    ticket: any;
    ticket_num_return: any = -1;
    ticket_print = 'normal'; //normal - indv
    ticket_print_ind: any;
    ticket_print_ind_number: any;
    ticket_print_ind_date: any;
    //Menus
    menusCol: AngularFirestoreCollection<Menu>;
    menus: Observable<Menu[]>;
    menusDoc: AngularFirestoreDocument<Menu>;
    menu: any;
    favourite_menus: Observable<Menu[]>;
    favourite_menus_count: number = 0;
    //Combos
    combosCol: AngularFirestoreCollection<Menu>;
    combos: Observable<Menu[]>;
    //Dish
    dishsCol: AngularFirestoreCollection<Dish>;
    dishs: Observable<Dish[]>;
    dishsDoc: AngularFirestoreDocument<Dish>;
    dish: any;
    dish_tags: any = Array();
    favourite_dishs: Observable<Dish[]>;
    favourite_dishs_count: number = 0;
    /*Send tag selected between components*/
    private subject = new Subject<any>();
    //Products
    productsCol: AngularFirestoreCollection<Product>;
    products: Observable<Product[]>;
    productsDoc: AngularFirestoreDocument<Product>;
    product: any;
    products_tags: any = Array();
    favourite_products: Observable<Product[]>;
    favourite_products_count: number = 0;
    /*Send tag selected between components*/
    private subjectProduct = new Subject<any>();
    //Cash
    cashsCol: AngularFirestoreCollection<Cash>;
    cashs: Observable<Cash[]>;
    cashsDoc: AngularFirestoreDocument<Cash>;
    cash: any;
    cashs_array = [];
    //Keyboard
    public keyboard_screen: string = '';
    public keyboard_blockscreen: string = '';
    //orders
    ordersCol: AngularFirestoreCollection<Order>;
    orders: Observable<Order[]>;
    orderDoc: AngularFirestoreDocument<Order>;
    //tmp
    one_time: boolean = true;


    constructor(public afs: AngularFirestore,
        public globals: Globals,
        public stockServices: StockServices,
        public translate: TranslateService,
        public modalCtrl: ModalController,
        public analyticsServices: AnalyticsServices) {
        this.firestore = firebase.firestore();
    }

    getRooms(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('config', 'rooms') != -1) {
            this.roomsCol = this.afs.collection('rooms', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).limit(this.globals.checkLimitsByLicense('config', 'rooms')));
            this.rooms = this.roomsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Room;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
        } else {
            this.roomsCol = this.afs.collection('rooms', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT));
            this.rooms = this.roomsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Room;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
        }

    }

    getTables(UID_RESTAURANT) {
        this.tablesCol = this.afs.collection('tables', ref => ref
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            //.where('type', '<', 'takeaway').orderBy('type', 'asc').orderBy('name', 'asc'));
            .where('type', '<', 'takeaway').orderBy('type', 'asc').orderBy('order', 'asc'));
        this.tables = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                return data;
            });
        });

        this.tablesCol.snapshotChanges().subscribe(value => {
            this.tables_array = [];
            value.map((a, index) => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                this.tables_array.push(data);
                //Anadimos el index de la tabla bar para poder utilizarlo.
                if (data.type == 'bar') {
                    this.table_bar_index = index;
                }
                return data;
            });
            //miramos si table seleccionada esta pagada
            this.checkIfTablePaid()
        });
    }

    getTablesRoom(UID_RESTAURANT, room_uid) {
        this.tablesCol = this.afs.collection('tables', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('uid_room', '==', room_uid));
        this.tables = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

    //Limpiamos array para subir a firebase
    cleanTicketArray() {
        for (let key in this.table_tmp.ticket.list) {
            delete this.table_tmp.ticket.list[key].variation_array;
            delete this.table_tmp.ticket.list[key].variation_add;
        }
    }

    //Creamos temporal de variacions del plato
    variations_tmp = Array();

    //Inserta un elemento en una mesa
    insertTable(_name, _price, _delete, _count, _type, _uid, sec, _element) {
        if (this.globals.ordersPersonsElements('order')) {//caso abrir comensales
            let profileModal = this.modalCtrl.create(PosElementPersonPage,
                {
                    title: _name,
                    number_persons: this.tables_array[this.selected_table_tpv_index].persons,
                });
            profileModal.onDidDismiss(data => {
                //check price
                if (_price == undefined) {
                    _price = 0;
                }
                //check tags
                if (_element.tags == undefined) {
                    _element.tags = [];
                }
                //check type_unit
                if (_element.type_unit == undefined) {
                    _element.type_unit = 'ud';
                }
                //check tax
                if (_element.tax == undefined) {
                    _element.tax = parseFloat(this.globals.user_tax);
                }
                //create object
                var obj = {
                    count: _count,
                    delete: _delete,
                    name: _name,
                    price: _price,
                    tax: _element.tax,
                    type: _type,
                    uid_element: _uid,
                    units: 1,
                    change: '',
                    finish: '',
                    state: 'normal',
                    variations: [],
                    person: data,
                    tags: _element.tags,
                    type_unit: _element.type_unit
                }
                //case scale add units 1
                if (_element.type_unit === 'scale') {
                    obj.units = 1;
                }
                //modificacio
                var section = {};
                if (this.update_state) {
                    if (Object.keys(this.order_tmp).length == 0) {
                        section = {
                            name: sec,
                            list: {
                                0: obj,
                            },
                        }
                        this.order_tmp.push(section);

                    }
                } else {
                    var index = this.order_tmp.findIndex(x => x.name == sec);

                    if (index >= 0) {
                        //this.order_tmp[index].list.push(list);
                        var last_key = Object.keys(this.order_tmp[index].list)[Object.keys(this.order_tmp[index].list).length - 1]; //get the last key in the object
                        if (last_key == undefined) {
                            last_key = '0';//Iniciamos a 0 si esta undefined
                        }

                        this.order_tmp[index].list[Number(last_key) + 1] = obj;

                    } else {
                        section = {
                            name: sec,
                            list: {
                                0: obj,
                            },
                        }
                        this.order_tmp.push(section);
                    }
                }

                //data set waiter activity
                var extra_activity: any =
                {
                    'type': 'add',
                    'value': 1,
                    'source': 'orders',

                };
                this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
            });
            profileModal.present();
            //
        } else {//caso insertar sin mas
            //check price
            if (_price == undefined) {
                _price = 0;
            }
            //check tags
            if (_element.tags == undefined) {
                _element.tags = [];
            }
            //check type_unit
            if (_element.type_unit == undefined) {
                _element.type_unit = 'ud';
            }
            //check tax
            if (_element.tax == undefined) {
                _element.tax = parseFloat(this.globals.user_tax);
            }
            //create object
            var obj = {
                count: _count,
                delete: _delete,
                name: _name,
                price: _price,
                tax: _element.tax,
                type: _type,
                uid_element: _uid,
                units: 1,
                change: '',
                finish: '',
                state: 'normal',
                variations: [],
                person: null,
                tags: _element.tags,
                type_unit: _element.type_unit
            }
            //case scale add units 1
            if (_element.type_unit === 'scale') {
                obj.units = 1;
            }
            //modificacio
            var section = {};
            if (this.update_state) {
                if (Object.keys(this.order_tmp).length == 0) {
                    section = {
                        name: sec,
                        list: {
                            0: obj,
                        },
                    }
                    this.order_tmp.push(section);

                }
            } else {
                var index = this.order_tmp.findIndex(x => x.name == sec);

                if (index >= 0) {
                    //this.order_tmp[index].list.push(list);
                    var last_key = Object.keys(this.order_tmp[index].list)[Object.keys(this.order_tmp[index].list).length - 1]; //get the last key in the object
                    if (last_key == undefined) {
                        last_key = '0';//Iniciamos a 0 si esta undefined
                    }

                    this.order_tmp[index].list[Number(last_key) + 1] = obj;

                } else {
                    section = {
                        name: sec,
                        list: {
                            0: obj,
                        },
                    }
                    this.order_tmp.push(section);
                }
            }

            //data set waiter activity
            var extra_activity: any =
            {
                'type': 'add',
                'value': 1,
                'source': 'orders',

            };
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
        }

    }

    //Inserta un elemento con variaciones en una mesa
    insertTableWithVariation(_name, _price, _delete, _count, _type, _uid, units, sec, _element) {

        if (this.globals.ordersPersonsElements('order')) {//caso abrir comensales
            let profileModal = this.modalCtrl.create(PosElementPersonPage,
                {
                    title: _name,
                    number_persons: this.tables_array[this.selected_table_tpv_index].persons,
                });
            profileModal.onDidDismiss(data => {

                //insertar en mesa
                for (var i = 0; i < units; i++) {
                    //check price
                    if (_price == undefined) {
                        _price = 0;
                    }
                    //check tags
                    if (_element.tags == undefined) {
                        _element.tags = [];
                    }
                    //check type_unit
                    if (_element.type_unit == undefined) {
                        _element.type_unit = 'ud';
                    }
                    //check tax
                    if (_element.tax == undefined) {
                        _element.tax = parseFloat(this.globals.user_tax);
                    }
                    //create object
                    var obj = {
                        count: _count,
                        delete: _delete,
                        name: _name,
                        price: _price,
                        tax: _element.tax,
                        type: _type,
                        uid_element: _uid,
                        units: units,
                        change: '',
                        finish: '',
                        state: 'normal',
                        variations: this.variations_tmp,
                        person: data,
                        tags: _element.tags,
                        type_unit: _element.type_unit
                    }
                    //case scale add units 1
                    if (_element.type_unit === 'scale') {
                        obj.units = 1;
                    }
                    //create section
                    var section = {};
                    if (this.update_state) {
                        if (Object.keys(this.order_tmp).length == 0) {
                            section = {
                                name: sec,
                                list: {
                                    0: obj,
                                },
                            }
                            this.order_tmp.push(section);
                        }
                    } else {
                        var index = this.order_tmp.findIndex(x => x.name == sec);

                        if (index >= 0) {
                            //this.order_tmp[index].list.push(list);
                            var last_key = Object.keys(this.order_tmp[index].list)[Object.keys(this.order_tmp[index].list).length - 1]; //get the last key in the object
                            if (last_key == undefined) {
                                last_key = '0';//Iniciamos a 0 si esta undefined
                            }

                            this.order_tmp[index].list[Number(last_key) + 1] = obj;
                        } else {
                            section = {
                                name: sec,
                                list: {
                                    0: obj,
                                },
                            }
                            this.order_tmp.push(section);
                        }


                    }

                    //data set waiter activity
                    var extra_activity: any =
                    {
                        'type': 'add',
                        'value': 1,
                        'source': 'orders',

                    };
                    this.count_elements++;//insert ++
                }
                //setlog once
                this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
                this.variations_tmp = [];//clean array

            });
            profileModal.present();
            //
        } else {
            //insertar en mesa
            for (var j = 0; j < units; j++) {
                //check price
                if (_price == undefined) {
                    _price = 0;
                }
                //check tags
                if (_element.tags == undefined) {
                    _element.tags = [];
                }
                //check type_unit
                if (_element.type_unit == undefined) {
                    _element.type_unit = 'ud';
                }
                //check tax
                if (_element.tax == undefined) {
                    _element.tax = parseFloat(this.globals.user_tax);
                }
                //create object
                var obj = {
                    count: _count,
                    delete: _delete,
                    name: _name,
                    price: _price,
                    tax: _element.tax,
                    type: _type,
                    uid_element: _uid,
                    units: units,
                    change: '',
                    finish: '',
                    state: 'normal',
                    variations: this.variations_tmp,
                    person: null,
                    tags: _element.tags,
                    type_unit: _element.type_unit
                }
                //case scale add units 1
                if (_element.type_unit === 'scale') {
                    obj.units = 1;
                }
                //create section
                var section = {};
                if (this.update_state) {
                    if (Object.keys(this.order_tmp).length == 0) {
                        section = {
                            name: sec,
                            list: {
                                0: obj,
                            },
                        }
                        this.order_tmp.push(section);
                    }
                } else {
                    var index = this.order_tmp.findIndex(x => x.name == sec);

                    if (index >= 0) {
                        //this.order_tmp[index].list.push(list);
                        var last_key = Object.keys(this.order_tmp[index].list)[Object.keys(this.order_tmp[index].list).length - 1]; //get the last key in the object
                        if (last_key == undefined) {
                            last_key = '0';//Iniciamos a 0 si esta undefined
                        }

                        this.order_tmp[index].list[Number(last_key) + 1] = obj;
                    } else {
                        section = {
                            name: sec,
                            list: {
                                0: obj,
                            },
                        }
                        this.order_tmp.push(section);
                    }


                }

                //data set waiter activity
                var extra_activity: any =
                {
                    'type': 'add',
                    'value': 1,
                    'source': 'orders',

                };
                this.count_elements++;//insert ++
            }
            //setlog once
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
            this.variations_tmp = [];//clean array
        }


    }

    //Elimina un elemento de una mesa
    deleteTableList(valueSearch, index) {

        //delete element
        var position_element = Object.keys(this.order_tmp[index].list).find(k => this.order_tmp[index].list[k].name === valueSearch);
        delete this.order_tmp[index].list[Number(position_element)];

        //if section empty delete section
        if (Object.keys(this.order_tmp[index].list).length == 0) {
            this.order_tmp.splice(index, 1);
        }

        //data set waiter activity
        var extra_activity: any =
        {
            'type': 'remove',
            'value': 1,
            'source': 'orders',

        };
        this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
    }

    //Precio total de les elementos del ticket
    totalOrderSelected() {
        var total = 0;
        for (let order of this.order_tmp) {
            for (let list of this.globals.objectToArray(order.list)) {
                total += parseFloat(list.price); //Sumamos el precio del plato
                for (let variation of this.globals.objectToArray(list.variations)) {
                    total += parseFloat(variation.price);
                }
            }

        }
        return total;
    }

    //Precio total ticket sin impuestos
    totalOrderSelectedNoTax(tax) {
        var total = this.totalOrderSelected();
        var sub = total / ((tax + 100) / 100);
        return sub;
    }

    //Precio total de les elementos del ticket
    totalTicketSelected(index) {
        //total
        var total = 0;
        var _taxs = this.globals.showIvaProducts(this.tables_array[index].ticket.list);
        total += _taxs.total;
        //tip
        if (this.tables_array[index].ticket.tip) {
            total += parseFloat(this.tables_array[index].ticket.tip);
        }
        return total;
    }

    totalTicketSelectedNoTax(index, tax) {
        var _taxs = this.globals.showIvaProducts(this.tables_array[index].ticket.list);
        return _taxs.subtotal;
    }



    //Lista de elementos selecionados en una mesa
    listSelectedTicket(propertyName, inputArray) {
        //Inicializamnos los arrays
        var array_return = Array();
        var array_count = Array();
        var array_count_return = Array();
        var array_nocount = Array();
        var array_nocount_return = Array();
        var array_delete = Array();
        var array_delete_return = Array();


        //Separamos los valores del array conjunto por los array del coun, no count i delete
        inputArray.map(function (item) {
            if (item.count && !item.delete) {
                //count true
                array_count.push(item);
            } else if (!item.count && !item.delete) {
                //count false
                array_nocount.push(item);
            } else if (item.delete) {
                //Delete true
                array_delete.push(item);
            }
        });

        //Count
        array_count.map(function (item) {
            //Duplicate item
            item.units = 0;// Iniciamos las unidades
            item.variation_array = Array();

            var itemPropertyName = item[propertyName];
            if (itemPropertyName in array_count) {
                array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                if (item.variation) {//Comprovamos si tiene variaciones
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_count[itemPropertyName].variation_add += parseFloat(value.price);
                    }
                }
                item.duplicate = true;//Marcamos item como duplicado
            } else {
                array_count[itemPropertyName] = item;
                array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                array_count[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones

                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_count[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_count.forEach(value => {
            if (value.duplicate != true) {
                array_count_return.push(value);
            }
        });

        //No Count
        array_nocount.map(function (item) {
            //Duplicate item
            item.units = 0;// Iniciamos las unidades
            item.variation_array = Array();
            var itemPropertyName = item[propertyName];
            if (itemPropertyName in array_nocount) {
                array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                if (item.variation) {//Comprovamos si tiene variaciones
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                    }
                }
                item.duplicate = true;//Marcamos item como duplicado
            } else {
                array_nocount[itemPropertyName] = item;
                array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                array_nocount[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones
                    array_nocount[itemPropertyName].variation_array = Array();
                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_nocount.forEach(value => {
            if (value.duplicate != true) {
                array_nocount_return.push(value);
            }
        });

        //Delete
        array_delete.map(function (item) {
            //Duplicate item
            item.units = 0;// Iniciamos las unidades
            item.variation_array = Array();
            var itemPropertyName = item[propertyName];
            if (itemPropertyName in array_delete) {
                array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                if (item.variation) {//Comprovamos si tiene variaciones
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                    }
                }
                item.duplicate = true;//Marcamos item como duplicado
            } else {
                array_delete[itemPropertyName] = item;
                array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                array_delete[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones
                    array_delete[itemPropertyName].variation_array = Array();
                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_delete.forEach(value => {
            if (value.duplicate != true) {
                array_delete_return.push(value);
            }
        });

        array_return.push(array_count_return);
        array_return.push(array_nocount_return);
        array_return.push(array_delete_return);

        return array_return;//Devolvemos array con las cantidades agrupadas
    }

    //Actualiza el numoer de comensales
    tableUpdatePersons(persons) {
        var number_persons = 0;
        if (persons) {
            number_persons = persons;
        } else {
            number_persons = this.tables_array[this.selected_table_tpv_index].persons;
        }

        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            persons: number_persons,
        });
    }

    //Actualiza el numoer de comensales
    tableUpdateCustomer(customer) {
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            customer: customer,
        });
    }

    //Elimina todos los elementos del ticket
    cancelTicket() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: '',
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                tip: 0,
                list: {},
                created_at: new Date(),
                updated_at: new Date(),
            },
            state: 'open'
        });
    }

    //update table per el cambrer quan entra
    updateSelectTableWaiter() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                waiter: this.tables_array[this.selected_table_tpv_index].ticket.waiter,
                waiter_uid: this.tables_array[this.selected_table_tpv_index].ticket.waiter_uid,
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: '',
                list: {},
                tip: this.checkTip(this.table_tmp.ticket.tip),
            }
        });
    }

    totalTicketIndv(elements) {//Total del ticket individual
        var total = 0;
        for (let key in elements) {
            let value = elements[key];
            if (value.state_indv == 'selected') {
                total += value.price;
                for (let key_var in value.variation) {
                    total += value.variation[key_var].price;
                }
            }
        }
        this.total_ticket_indv_print = total;
        return total;
    }

    totalTicketIndvNoTax(elements, tax) {//Total del ticket individual no tax
        var total = this.totalTicketIndv(elements);
        //var sub =  total - (total * tax / 100);
        var sub = total / ((tax + 100) / 100);
        this.subtotal_ticket_indv_print = sub;
        return sub;
    }

    totalTicketIndvElementPrice(element) {//Total de un elemento individual del ticket indv
        var total = 0;
        total += element.price;
        for (let key_var in element.variation) {
            total += element.variation[key_var].price;
        }
        return total;
    }

    cleanTicketIndvSelectedArray() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        for (let key in this.table_tmp.ticket.list) {
            if (this.table_tmp.ticket.list[key].state_indv === 'selected') {
                this.table_tmp.ticket.list[key].state_indv = 'pay';
                this.updateTableNumber(this.table_tmp.ticket.number);
            }
        }
    }

    async updateTableNumber(number) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        //Actualizamos la tabla de la base de datos
        await this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: new Date(),
                number: number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            state: 'close'
        });

    }

    tableUpdateCash(cash) {//funcion que actuliza la caja del ticket de la table
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            cash_static: cash.name,
            cash_uid: cash.UID,
        });
    }


    /*async cashTicketPay(payment_type, type) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Restamos stock
        this.stockServices.deductStock(this.table_tmp.ticket.list);

        //Eliminamos el camp variation array para poder hacer el update
        await this.cleanTicketArray();
        await this.getTicketNumber(this.globals.restaurant_uid, this.table_tmp.cash_uid);


        this.afs.collection('tickets').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            amount: this.totalTicketSelected(),
            tax: this.globals.RESTAURANT_TAX,
            cash_static: this.table_tmp.cash_static,
            cash_uid: this.table_tmp.cash_uid,
            date: this.table_tmp.ticket.date,
            list: this.table_tmp.ticket.list,
            number: this.ticket_num_return,
            payment: true,
            payment_type: payment_type,
            waiter: this.table_tmp.ticket.waiter,
            waiter_uid: this.table_tmp.ticket.waiter_uid,
            type: type,
            closed: false,
            table_uid: this.table_tmp.UID,
            pending: false,

        }).then(value => {
        });
    }*/

    //Funcion que busca el ultimo numero del ticket y hace update. Controla los numero por cajas y hace una serie diferente por caja
    async getTicketNumber(UID_RESTAURANT, cash_uid) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        var _ticket_num_return = -1;
        //this.ticket_num_return = -1;//Reiniciamos el numero para encontrar el nuevo

        if (!this.table_tmp.ticket.number) {//Comprovamos si el ticket ya tiene un numero para no darle uno de nuevo
            var col = this.firestore.collection('cashs').doc(this.table_tmp.cash_uid);
            await col.get()
                .then(async doc => {
                    var doc = doc.data()

                    _ticket_num_return = doc.number + 1;
                    this.ticket_num_return = _ticket_num_return;
                    this.tables_array[this.selected_table_tpv_index].ticket.number = _ticket_num_return;
                    await this.updateTableNumber(_ticket_num_return);
                    await this.cashUpdateNumber(this.table_tmp.cash_uid, _ticket_num_return);
                });
            /*
            this.cashs_array.forEach(value => {

                if (value.UID == cash_uid) {
                    _ticket_num_return = value.number + 1;
                    this.ticket_num_return = _ticket_num_return;
                    this.updateTableNumber(_ticket_num_return);
                    this.cashUpdateNumber(value.UID, _ticket_num_return);
                }
            });*/
        } else {
            this.ticket_num_return = this.table_tmp.ticket.number;
        }

        return true;

    }

    getMenus(UID_RESTAURANT) {
        this.menusCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('type', '==', 'menu')
            .orderBy('title_es', 'asc'));
        this.menus = this.menusCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Menu;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
        });
    }

    getCombos(UID_RESTAURANT) {
        this.combosCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('type', '==', 'combo')
            .orderBy('title_es', 'asc'));
        this.combos = this.combosCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Menu;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
        });
    }

    getFavouriteMenus(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.menusCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy('title_es', 'asc'));
            this.favourite_menus = this.menusCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Menu;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
            //
            this.menusCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Menu;
                    data.UID = a.payload.doc.id;
                    this.favourite_menus_count++;
                });
            });
        }
    }

    getDish(UID_RESTAURANT) {
        this.dishsCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .orderBy(this.globals.returnLangTag('dish'), 'asc'));
        this.dishs = this.dishsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Dish;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
        });

        //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
        this.dishsCol.snapshotChanges().subscribe(value => {
            value.map(a => {
                const data = a.payload.doc.data() as Dish;
                data.UID = a.payload.doc.id;
                if (data.tags) {
                    data.tags.forEach(value => {//Insert to array all dish tags
                        this.dish_tags.push(value.toLowerCase());
                    });
                }
            });

            this.dish_tags = this.cleanDuplicates(this.dish_tags);//Clean duplicates dish tags to the array
            this.dish_tags = this.globals.orderNamesByAlphabetical(this.dish_tags);//order alphabetic
        });
    }

    async chargeElementsActiveTags() {
        //limpiamos el arrat de tags activos
        this.elements_active_tags = [];
        this.elements_tags = [];

        await this.getTags();
        this.elements_tags = await this.elements_tags.concat(this.dish_tags);
        this.elements_tags = await this.elements_tags.concat(this.products_tags);
        await this.elements_tags.sort((a, b) => a.localeCompare(b));
        await this.elements_tags.unshift(this.translate.instant('general-todos'));
        // await this.chargeListTagas();

        //recorremos todos los tagas
        this.elements_tags.forEach(element => {
            //comprobamos que cada tags este activo o no
            if (this.checkElementActive(element)) {
                //SI ESTA activo lo añadimos al array y marcamos como ACTIVO
                this.elements_active_tags.push({ name: element, active: true })
            } else {
                //si NO ESTA activo lo añadimos al array y marcamos como DESACTIVO
                this.elements_active_tags.push({ name: element, active: false })
            }
        });
    }

    checkElementActive(name) {
        let _name: string = name;
        let tag_is_active = false;

        if (this.active_tags.length == 0) {
            return tag_is_active;
        }
        this.active_tags.forEach(element => {
            let _element: string = element;
            if (_element == _name) {
                tag_is_active = true;
            }
        });
        return tag_is_active;
    }

    getFavouriteDishes(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.dishsCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy(this.globals.returnLangTag('dish'), 'asc'));
            this.favourite_dishs = this.dishsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Dish;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });

            //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
            this.dishsCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Dish;
                    data.UID = a.payload.doc.id;
                    this.favourite_dishs_count++;
                });
            });
        }

    }

    sendTagDish(message: string) {
        this.subject.next({ message });
    }

    getTagDish(): Observable<any> {
        return this.subject.asObservable();
    }

    getProducts(UID_RESTAURANT) {
        this.productsCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .orderBy(this.globals.returnLangTag('product'), 'asc'));
        this.products = this.productsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Product;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectProduct(a).localeCompare(this.globals.nameLangSelectProduct(b)));
        });

        //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
        this.productsCol.snapshotChanges().subscribe(value => {
            value.map(a => {
                const data = a.payload.doc.data() as Product;
                data.UID = a.payload.doc.id;
                if (data.tags) {
                    data.tags.forEach(value => {//Insert to array all dish tags
                        this.products_tags.push(value.toLowerCase());
                    });
                }
            });
            this.products_tags = this.cleanDuplicates(this.products_tags);//Clean duplicates dish tags to the array
            this.products_tags = this.globals.orderNamesByAlphabetical(this.products_tags);//order alphabetic

        });


    }

    getFavouriteProducts(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.productsCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy(this.globals.returnLangTag('product'), 'asc'));
            this.favourite_products = this.productsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Product;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });

            //Funcion importante para cuando tienes que trabajar con los datos recuperados de toda una collection
            this.productsCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Product;
                    data.UID = a.payload.doc.id;
                    this.favourite_products_count++;
                });
            });
        }
    }

    sendTagProduct(message: string) {
        this.subjectProduct.next({ message });
    }

    getTagProduct(): Observable<any> {
        return this.subjectProduct.asObservable();
    }

    getCashs(UID_RESTAURANT) {
        this.cashsCol = this.afs.collection('cashs', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('number', 'desc'));
        this.cashs = this.cashsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Cash;
                data.UID = a.payload.doc.id;
                return data;
            });
        });

        this.cashsCol.snapshotChanges().subscribe(value => {
            this.cashs_array = [];
            value.map(a => {
                const data = a.payload.doc.data() as Cash;
                data.UID = a.payload.doc.id;
                data._active = true;
                if (this.cashs_array.length >= 1 && !this.globals.checkLimitsByLicense('config', 'multi_cash')) {
                    data._active = false;
                }
                this.cashs_array.push(data);

                return data;
            });

        });

    }

    getCashNumber() {
        this.cashs_array.forEach(value => {
        });
    }

    async cashUpdateNumber(uid, number) {
        //Actualizamos la tabla de la base de datos
        await this.afs.collection('cashs').doc(uid).update({
            number: number,
        });
    }

    async getCash(cash_uid) {
        const cashRef = this.firestore.collection('cashs').doc(cash_uid);

        var _cash;

        await
            cashRef.get().then(doc => {
                _cash = doc.data();
                _cash.UID = doc.id;
            });

        return _cash
    }

    insertKeyboard(number) {
        this.keyboard_screen = this.keyboard_screen + '' + number;
    }

    deleteKeyboard() {
        this.keyboard_screen = '';
    }

    insertKeyboardBlockscreen(number) {
        this.keyboard_blockscreen = this.keyboard_blockscreen + '' + number;
    }

    deleteKeyboardBlockscreen() {
        this.keyboard_blockscreen = '';
    }

    //Help
    cleanDuplicates(arr) {
        var unique = arr.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
        });
        return unique;
    }

    async getOrdersF(UID_RESTAURANT, table_uid) {

        const ordersRef = this.firestore.collection('orders');

        var orders = [];

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var order = doc.data();
                    order.UID = doc.id;

                    orders.push(order);
                });
            });

        return orders
    }

    async getOrdersAllPrint(UID_RESTAURANT, table_uid) {
        this.listall_print = [];

        const ordersRef = this.firestore.collection('orders');

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var order = doc.data();
                    order.UID = doc.id;

                    this.listall_print.push(order);
                });
            });
    }

    async getOrdersLastPrint(UID_RESTAURANT, table_uid) {
        this.listchange_print = [];
        var _listchange_print = [];

        const ordersRef = this.firestore.collection('orders');

        await ordersRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var order = doc.data();
                    order.UID = doc.id;

                    _listchange_print.push(order);
                });
            });
        this.listchange_print.push(_listchange_print[0]);
    }

    getOrders(UID_RESTAURANT, table_uid) {
        this.ordersCol = this.afs.collection('orders', ref => ref
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid)
            .orderBy('date', 'desc'));
        this.orders = this.ordersCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Order;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
    }

    async deleteOders(UID_RESTAURANT, table_uid) {
        var jobskill_query = this.firestore.collection('orders')
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_order', '==', true)
            .where('table_uid', '==', table_uid);
        jobskill_query.get().then(snapshot => {
            snapshot.forEach(doc => {
                var order = doc.data();
                order.UID = doc.id;

                for (let section of order.sections) {
                    for (let list of section.list) {
                        list.state = 'delete';
                    }
                }
                this.firestore.collection('orders').doc(order.UID).update({
                    show_order: false,
                    sections: order.sections
                });
            });
        });
    }

    changeState(state) {
        this.orders_print = state;
        var _state = state;
        return _state;
    }

    async getAccessCodes() {

        const ordersRef = this.firestore.collection('users');

        var users = [];

        await ordersRef.get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var user = doc.data();
                    user.UID = doc.id;
                    users.push(user);
                });
            });

        return users
    }

    async deleteOrdersWhenPay(UID_RESTAURANT, table_uid) {
        //get orders of table
        var jobskill_query = this.firestore.collection('orders')
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('table_uid', '==', table_uid);
        jobskill_query.get().then(snapshot => {
            snapshot.forEach(doc => {
                //delete
                doc.ref.delete();
            });
        });
    }

    async deleteTableTKWhenCloseCash(table_uid) {
        this.afs.doc('tables/' + table_uid).delete();
    }

    async deleteOrdersTKWhenCancelTicket(UID_RESTAURANT) {
        //get orders of table
        var jobskill_query = this.firestore.collection('orders')
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('show_kitchen', '==', true)
            .where('show_order', '==', false);
        jobskill_query.get().then(snapshot => {
            snapshot.forEach(doc => {
                //delete
                doc.ref.delete();
            });
        });
    }

    async deleteKitchenHiddenOrders(UID_RESTAURANT) {
        //get orders of table
        var jobskill_query = this.firestore.collection('kitchen_hidden')
            .where('UID_RESTAURANT', '==', UID_RESTAURANT);
        jobskill_query.get().then(snapshot => {
            snapshot.forEach(doc => {
                //delete
                doc.ref.delete();
            });
        });
    }

    async sendOrderInServices() {
        var today = new Date();
        var _order_tmp = [];
        //insert to orders
        _order_tmp = [];

        var _elements_list = [];
        for (let order of this.order_tmp) {
            var _list = [];
            var _combo_section = true;
            for (let list of this.globals.objectToArray(order.list)) {
                var obj = {};
                if (list.uid_combo_tmp != undefined) {
                    obj = {
                        name: list.name,
                        change: list.change,
                        finish: list.finish,
                        state: list.state,
                        variations: list.variations,
                        uid_combo_tmp: list.uid_combo_tmp,
                        uid_element_combo: list.uid_element_combo,
                        person: this.ifPersonEmpty(list.person),
                        tags: list.tags,
                        uid_element: list.uid_element
                    }
                    if (list.type == 'combo') {
                        _combo_section = false;
                    }
                } else {
                    obj = {
                        name: list.name,
                        change: list.change,
                        finish: list.finish,
                        state: list.state,
                        variations: list.variations,
                        person: this.ifPersonEmpty(list.person),
                        tags: list.tags,
                        uid_element: list.uid_element
                    }
                    _combo_section = false;
                }
                //check type_unit and add
                if (list.type_unit) {
                    obj['type_unit'] = list.type_unit;
                }
                _list.push(obj);
                //guardamos el elemento para insertarlo en la analytics WAITER
                _elements_list.push(list.name);
            }
            var _oder = {
                name: order.name,
                list: _list,
                only_combo: _combo_section,
            }
            _order_tmp.push(_oder);
        }

        //preparamos la extroctura del insert para _data analytics WAITER
        var waiter = {
            'uid': this.globals.restaurant_uid,
            'waiter': this.globals.waiter,
            'elements': _elements_list,
            'date': new Date(),
            'type': "waiter",
            'type_type': "ADD",
        };
        this.analyticsServices.sendWaiter(waiter);

        //get customer
        var _customer = [];
        if (this.tables_array[this.selected_table_tpv_index].customer) {
            _customer = this.tables_array[this.selected_table_tpv_index].customer;
        }

        await this.afs.collection('orders').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'date': today,
            'hour': moment(today).format("HH:mm"),
            'sections': _order_tmp,
            'show_kitchen': true,
            'show_order': true,
            'table': this.tables_array[this.selected_table_tpv_index].name,
            'table_uid': this.tables_array[this.selected_table_tpv_index].UID,
            'type': 'table',
            'waiter': this.globals.waiter,
            'waiter_uid': this.globals.waiter_uid,
            'created_at': new Date(),
            'updated_at': new Date(),
            'notes': this.globals.ifVarEmpty(this.customer_note),
            'datetime_pickup_delivey': new Date(),
            'customer': _customer,
        }).then(doc => { });


        //insert to table
        this.table_tmp = this.tables_array[this.selected_table_tpv_index];
        //close manually state table
        this.tables_array[this.selected_table_tpv_index].state = 'close';

        _order_tmp = [];
        for (let order of this.order_tmp) {
            _list = [];
            for (let list of this.globals.objectToArray(order.list)) {

                var last_key = Object.keys(this.table_tmp.ticket.list)[Object.keys(this.table_tmp.ticket.list).length - 1]; //get the last key in the object
                if (last_key == undefined) {
                    last_key = '-1';//Iniciamos a 0 si esta undefined
                }
                //para evitar insertar caso elementos de combo
                if ((list.type == 'combo' && list.uid_combo_tmp != undefined) || (list.type != 'combo' && list.uid_combo_tmp == undefined)) {
                    if (list.uid_combo_tmp != undefined) {
                        this.table_tmp.ticket.list[Number(last_key) + 1] = {// es elemento de combo
                            name: list.name,
                            price: list.price,
                            delete: list.delete,
                            count: list.count,
                            type: list.type,
                            uid_element: list.uid_element,
                            variation: list.variations,
                            waiter: this.globals.waiter,
                            waiter_uid: this.globals.waiter_uid,
                            uid_combo_tmp: list.uid_combo_tmp,
                            uid_element_combo: list.uid_element_combo,
                            tags: list.tags,
                        };
                    } else {
                        this.table_tmp.ticket.list[Number(last_key) + 1] = {// articles
                            name: list.name,
                            price: list.price,
                            delete: list.delete,
                            count: list.count,
                            tax: list.tax,
                            type: list.type,
                            uid_element: list.uid_element,
                            variation: list.variations,
                            waiter: this.globals.waiter,
                            waiter_uid: this.globals.waiter_uid,
                            tags: list.tags,
                        };
                    }
                    //check type_unit and add
                    if (list.type_unit == undefined) {
                        list.type_unit = 'ud';
                    }
                    if (list.type_unit) {
                        this.table_tmp.ticket.list[Number(last_key) + 1].type_unit = list.type_unit;
                        if (list.type_unit === 'scale') {
                            this.table_tmp.ticket.list[Number(last_key) + 1].units = 1;
                        }
                    }
                }
            }

            //reinicia menu lateral tags
            //this.ordersCoServices.section_select = 'Menu';
            this.menu_select = '';
        }
        //Actualizamos la tabla de la base de datos
        var _created_at;
        if (this.table_tmp.ticket.created_at == '' || this.table_tmp.ticket.created_at == undefined) {
            _created_at = new Date();
        } else {
            _created_at = this.table_tmp.ticket.created_at;
        }

        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: today,
                number: this.table_tmp.ticket.number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: _created_at,
                updated_at: new Date(),
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            state: 'close',
            'notes': this.globals.ifVarEmpty(this.customer_note)
        }).then(async doc => {
            this.cleanVariables();
        });
    }

    async updateInsertTPV(name) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index];

        for (let list of this.globals.objectToArray(this.table_tmp.ticket.list)) {
            if (list.name == name && this.one_time && list.delete == false && list.count == true) {
                list.count = false;
                list.delete = true;
                this.one_time = false;
            }
        }

        var last_key = Object.keys(this.table_tmp.ticket.list)[Object.keys(this.table_tmp.ticket.list).length - 1]; //get the last key in the object
        if (last_key == undefined) {
            last_key = '-1';//Iniciamos a 0 si esta undefined
        }

        this.table_tmp.ticket.list[Number(last_key) + 1] = {//Creamos objeto del nuevo plato
            name: this.order_tmp[0].list[0].name,
            price: this.order_tmp[0].list[0].price,
            delete: this.order_tmp[0].list[0].delete,
            count: this.order_tmp[0].list[0].count,
            type: this.order_tmp[0].list[0].type,
            uid_element: this.order_tmp[0].list[0].uid_element,
            variation: this.order_tmp[0].list[0].variations,
            waiter: this.globals.waiter,
            waiter_uid: this.globals.waiter_uid,
        };

        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: this.table_tmp.ticket.number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                updated_at: new Date(),
                created_at: this.table_tmp.ticket.created_at,
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            state: 'close'
        }).then(async doc => {
            this.update_state = false;
            this.i = '';
            this.j = '';
            this.element = '';
            this.order_tmp = [];
        });
    }

    async openModSelect() {

        this.element.sections[this.i].list[this.j].change = this.order_tmp[0].list[0].name;
        this.element.sections[this.i].list[this.j].state = 'change';
        this.element.sections[this.i].list[this.j].finish = '';
        this.element.sections[this.i].list[this.j].waiter = this.globals.waiter;
        this.element.sections[this.i].list[this.j].waiter_uid = this.globals.waiter_uid;
        this.element.sections[this.i].list[this.j].variations = this.order_tmp[0].list[0].variations;

        this.afs.collection('orders').doc(this.element.UID).update({
            sections: this.element.sections,
            updated_at: new Date(),
        }).then(async doc => {
            await this.updateInsertTPV(this.element.sections[this.i].list[this.j].name);
        });
        //insert _data analytics WAITER
        let _element = [];
        _element.push(this.element.sections[this.i].list[this.j].name + " > " + this.order_tmp[0].list[0].name)
        var waiter = {
            'uid': this.globals.restaurant_uid,
            'waiter': this.globals.waiter,
            'elements': _element,
            'date': new Date(),
            'type': "waiter",
            'type_type': "MODIFY",
        };
        this.analyticsServices.sendWaiter(waiter);
    }

    checkTip(quantity) {
        var tip_amount = 0;
        if (quantity) {
            tip_amount = quantity;
        }
        return tip_amount;
    }

    cleanVariables() {
        this.order_tmp = [];
        this.section_order = this.translate.instant('general-todos');
        this.section_menu_order = this.translate.instant('general-primeros');
        this.menu_select = '';
        this.count_elements = 0;
    }

    ifPersonEmpty(person) {
        if (person != undefined) {
            return person;
        } else {
            return '';
        }
    }

    getTags() {
        if (this.dish_tags.length == 0) {
            this.getDish(this.globals.restaurant_uid);
        }
        if (this.products_tags.length == 0) {
            this.getProducts(this.globals.restaurant_uid);
        }
    }

    checkIfTablePaid() {
        //
        if (this.selected_table_tpv_index != undefined) {
            //
            if (this.selected_table_tpv_index >= 0 && this.globals.side_menu_active == 'order') {
                //
                if (this.tables_array[this.selected_table_tpv_index] != undefined) {
                    //
                    if (this.tables_array[this.selected_table_tpv_index].payment && this.tables_array[this.selected_table_tpv_index].payment_source != '' && !this.globals.table_paid_alert) {
                        //
                        this.globals.launchAlertTablePaid(this.tables_array[this.selected_table_tpv_index], 'orders');
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/orders/services.ts